export default "__VITE_ASSET__l0$PPixp__"